"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.moveSelection = exports.drawAll = exports.close = exports.open = exports.isOpen = exports.get = exports.quote = void 0;
exports.quote = "\"It was the [green|best] of times, it was the [red|worst] of times, it was the [wave|age of] [rainbowwave|wisdom], it was the age of foolishness, it was the epoch of belief, it was the epoch of incredulity, it was the season of light, it was the season of [dark|darkness], it was the spring of [green|hope], it was the winter of [red|despair].\"\n- Charles Dickens, A Tale of Two Cities";
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueKeyboard_directInput_sidecar_1 = require("../input/rogueKeyboard_directInput-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_playerCustomization_1 = require("../monsters/rogueMonsters_playerCustomization");
var rogueMonsters_playerCustomization_sidecar_1 = require("../monsters/rogueMonsters_playerCustomization-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        var imageTileBorder = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().uiGame, sprites_sidecar_1.sprites.rogueBorder[0]);
        spritesUtil_sidecar_1.spritesUtil.scale(imageTileBorder, rogueDef_sidecar_1.rogueDef.scale);
        imageTileBorder.visible = false;
        _obj = {
            isOpen: false,
            elapsed: 0,
            appearanceMenuIdx: 0,
            imageCursor: imageTileBorder,
            step: 1,
        };
    }
    return _obj;
};
exports.get = get;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function () {
    var obj = (0, exports.get)();
    obj.elapsed = 0;
    obj.isOpen = true;
    obj.imageCursor.visible = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
    obj.imageCursor.visible = false;
    rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.clearKeyEntryMode('create-character');
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    obj.elapsed += common_sidecar_1.common.getUpdateDelta();
    obj.imageCursor.visible = Math.floor(obj.elapsed * 2) % 2 === 0;
    if (obj.step !== 0) {
        obj.imageCursor.visible = false;
    }
    var x = 1;
    var y = 1;
    var nextStep = obj.step;
    y++;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Create Character', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
    var pc = rogueMonsters_playerCustomization_sidecar_1.rogueMonsters_playerCustomization.get();
    if (obj.step === 0) {
        rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.setKeyEntryMode('create-character', pc.name, 12);
        y++;
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'What is thy name?', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
        pc.name = rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.getDirectKeyboardInputBuffer();
        rogueDef_sidecar_1.rogueDef.moveTile(obj.imageCursor, x + pc.name.length + 0.5, y + 0.5);
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, pc.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark);
        y++;
        if (rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.isEnterQueued()) {
            pc.name = pc.name.trim();
            rogueMonsters_playerCustomization_sidecar_1.rogueMonsters_playerCustomization.save();
            nextStep = obj.step + 1;
            rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.clearKeyEntryMode('create-character');
        }
        if (rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.isEscapeQueued()) {
            (0, exports.cancel)();
        }
    }
    if (obj.step === 1) {
        rogueKeyboard_directInput_sidecar_1.rogueKeyboard_directInput.clearKeyEntryMode('create-character');
        y++;
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, "Welcome to the dungeon, ".concat(pc.name, "."), rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y += 2;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, "What do you look like?", rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
        var caret = function (idx) { return (obj.appearanceMenuIdx === idx ? '> ' : '  '); };
        var appearance = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(rogueMonsters_playerCustomization_1.appearances, pc.appearanceIdx);
        var color = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(rogueMonsters_playerCustomization_1.skinColors, pc.skinColorIdx);
        var hat = entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(rogueMonsters_playerCustomization_1.hats, pc.hatIdx);
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, caret(0) + appearance.value, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, caret(1) + color.value, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, caret(2) + hat.value, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
        y++;
    }
    obj.step = nextStep;
};
exports.drawAll = drawAll;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    if (obj.step === 1) {
        var pc = rogueMonsters_playerCustomization_sidecar_1.rogueMonsters_playerCustomization.get();
        if (obj.appearanceMenuIdx === 0) {
            pc.appearanceIdx += ox;
        }
        if (obj.appearanceMenuIdx === 1) {
            pc.skinColorIdx += ox;
        }
        if (obj.appearanceMenuIdx === 2) {
            pc.hatIdx += ox;
        }
        obj.appearanceMenuIdx += oy;
        obj.appearanceMenuIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(obj.appearanceMenuIdx, [0, 1, 2]);
        rogueMonsters_playerCustomization_sidecar_1.rogueMonsters_playerCustomization.save();
    }
};
exports.moveSelection = moveSelection;
var select = function () {
    var obj = (0, exports.get)();
    if (obj.step === 1) {
        (0, exports.close)();
    }
};
exports.select = select;
var cancel = function () {
    var obj = (0, exports.get)();
    console.log('cancel create char', obj.step);
    if (obj.step === 0) {
        (0, exports.close)();
        return;
    }
    if (obj.step === 1) {
        obj.step = 0;
        return;
    }
};
exports.cancel = cancel;
